import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-notice',
  templateUrl: './sidebar-notice.component.html',
})
export class SidebarNoticeComponent {}
